export default "__VITE_ASSET__BU8Bdtg___"